import React, { Component } from 'react'
import { translate } from "react-i18next"
import { EMAIL_REGEX } from 'cogsworth/constants'
import './guests.css'

const MAX_GUESTS = 25

const NEW_GUEST_STATE = {
  name: "",
  email: "",
  phoneMobile: "",
}

class InputGuests extends Component {
  constructor(props){
    super(props)

    this.state = {
      guests: props.value || [],
      error: false,
      newGuest: NEW_GUEST_STATE,
    }

    this.removeGuest = this.removeGuest.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.validate = this.validate.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleAddGuestClick = this.handleAddGuestClick.bind(this)
  }

  componentDidMount(){
    if(document.hasFocus()) {
      this.nameInput.focus()
    }
  }

  handleSubmit(){
    const { newGuest } = this.state
    if (newGuest.email !== "" || newGuest.name !== "" || newGuest.phoneMobile !== "") {
      this.handleAddGuestClick({ submitOnSuccess: true })
      return
    }

    if(this.props.onSubmit){
      this.props.onSubmit(this.state.guests)
    } else {
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
    }
  }

  addGuest({ submitOnSuccess=false }){
    this.setState({
      guests: [ ...this.state.guests, this.state.newGuest ],
      newGuest: NEW_GUEST_STATE,
    }, () => {
      if (submitOnSuccess) {
        this.handleSubmit()
      }
    })
  }

  validate() {
    const { name, email, phoneMobile } = this.state.newGuest

    if (name.length === 0) {
      this.setState({ error: 'name' })
      this.nameInput.focus()
      return false
    }

    if (email.length === 0 || !EMAIL_REGEX.test(email)) {
      this.setState({ error: 'email' })
      this.emailInput.focus()
      return false
    }

    if (phoneMobile.length > 0) {
      const regex = /^[+]*[-\s./0-9]*$/gi
      if (!regex.test(phoneMobile)) {
        this.setState({ error: 'phone' })
        this.phoneInput.focus()
        return false
      }
    }

    this.setState({ error: null })
    return true
  }

  removeGuest(index){
    let guests = this.state.guests
    guests.splice(index, 1)

    this.setState({ guests })
  }

  handleKeyDown(e){
    if( e.keyCode === 13 ) { // Enter
      e.preventDefault()

      if (e.target.name === 'name') {
        this.emailInput.focus()
      } else if (e.target.name === 'email') {
        this.phoneInput.focus()
      } else if (e.target.name === 'phoneMobile') {
        this.handleAddGuestClick({ submitOnSuccess: false })
      }
    }
  }

  handleInputChange(e) {
    const { name, value } = e.target

    this.setState({
      newGuest: {
        ...this.state.newGuest,
        [name]: value,
      },
    })
  }

  renderGuests() {
    if (this.state.guests.length === 0) {
      return (
        <div className="guest">
          No guests added yet.
        </div>
      )
    }
    return this.state.guests.map((guest, index) => {
      return (
        <div className="guest" key={`guest-${index}`}>
          <strong>{ guest.name }</strong>: { guest.email }{ guest.phoneMobile && ` - ${guest.phoneMobile}` }
          <div className="btn-remove fa fa-trash" onClick={() => { this.removeGuest(index) }}></div>
        </div>
      )
    })
  }

  handleAddGuestClick({ submitOnSuccess }) {
    if (!this.validate()) {
      return
    }

    this.nameInput.focus()
    this.addGuest({ submitOnSuccess })
  }

  renderInput() {
    if (this.state.guests.length >= MAX_GUESTS) {
      return null
    }

    const guest = this.state.newGuest

    return (
      <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
        <div className="input">
          <input className={this.state.error === 'name' ? 'error' : ''} ref={el=>this.nameInput=el} type="text" id={`${this.props.id}-name`} name="name" placeholder="name" onChange={this.handleInputChange} value={guest.name} onKeyDown={this.handleKeyDown} />
          <input className={this.state.error === 'email' ? 'error' : ''} ref={el=>this.emailInput=el} type="email" id={`${this.props.id}-email`} name="email" placeholder="email" onChange={this.handleInputChange} value={guest.email} onKeyDown={this.handleKeyDown} />
          <input className={this.state.error === 'phone' ? 'error' : ''} ref={el=>this.phoneInput=el} type="text" id={`${this.props.id}-phone`} name="phoneMobile" placeholder="mobile phone" onChange={this.handleInputChange} value={guest.phoneMobile} onKeyDown={this.handleKeyDown} />
          <button id="add-guest" onClick={() => { this.handleAddGuestClick({ submitOnSuccess: false }) }} className="font-primary-color border-primary-color light-primary-background">add</button>
        </div>
      </div>
    )
  }

  render() {
    const { color } = this.props

    return (
      <div className="booking-input booking-input-guests inside-button">
        { this.renderInput() }
        { this.renderGuests() }
        <button className="btn-submit" onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
      </div>
    )
  }
}

export default translate("translations")(InputGuests)
